import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Errors, Control, actions } from 'react-redux-form';
import { Panel, Row, Col, FormControl, FormGroup, Checkbox, Radio } from 'react-bootstrap';
import classnames from 'classnames';
import { inviteStaff, saveStaffMember, removeStaffMember } from '../../actions/staff';
import UserTitleSelector from '../common/form/user/user-title-selector';
import UserFirstNameInput from '../common/form/user/user-first-name-input';
import UserLastNameInput from '../common/form/user/user-last-name-input';
import RequiredSelect from '../common/form/elements/required-select';
import ArrowButton from '../common/button-arrow';
import { validators } from '../../utils/validators';
import UserJobTitleSelector from '../common/form/user/user-job-title-selector';

class EditStaff extends Component {
  constructor(props){
    super(props);

    this.state = {
      selectedOutlet: props.staff_member_relationships.outlets.find(outlet => outlet.id === +props.staff_member.outlet_id)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.staff_member_relationships && nextProps.staff_member.outlet_id) {
      this.setState({
        selectedOutlet: nextProps.staff_member_relationships.outlets.find(outlet => outlet.id === +nextProps.staff_member.outlet_id)
      });
    }
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  onStaffAdded = (payload) => {
    if (this.props.staff_member_id !== -1) {
      this.props.dispatch(actions.submitFields('deep.staff_member', saveStaffMember(payload, this.props.saveLink)));
    } else {
      this.props.dispatch(actions.submitFields('deep.staff_member', inviteStaff(payload)));
    }
  };

  onRemoveFromStore = () => {
    this.props.dispatch(removeStaffMember(this.props.removeLink, this.props.staff_member_id, this.props.staff_member.outlet_id));
  };

  onOutletChanged = (id) => {
    this.setState({
      selectedOutlet: this.props.staff_member_relationships.outlets.find(outlet => outlet.id === +id)
    })
  };

  render() {
    const { staff_member, staff_member_id, staff_member_relationships, staff_member_status, formValid } = this.props;

    return(this.props.open &&
      <Col className={'open-staff-panel'} md={12}>
        <Panel className={classnames('edit-staff-panel', staff_member_status)}>
          <Form model="deep.staff_member"
                validators={{
                  '': {
                    communication: (vals) => vals.email || vals.mobile || vals.first_name || vals.last_name,
                    permissions: (vals) => staff_member_relationships.permissions && Object.keys(vals.permission_ids).length === staff_member_relationships.permissions.length
                  }
                }}
                onSubmit={this.onStaffAdded}>
            <Errors className="errors" model="deep.staff_member"/>
            <Row>
              <Col lg={4}>
                <UserTitleSelector label={''} />
                <UserFirstNameInput label={''} />
                <UserLastNameInput label={''} />
              </Col>
              <Col lg={4}>
                <RequiredSelect model=".outlet_id"
                                values={staff_member_relationships.outlets || []}
                                labelAttr='name'
                                valueAttr='id'
                                controlId="outletId"
                                onChange={this.onOutletChanged}/>

                <FormGroup controlId="email">
                  <Control model=".email" type="email" placeholder="Email" component={FormControl}/>

                  <Errors
                    show={{ touched: true }}
                    className="errors"
                    model=".email"/>
                </FormGroup>

                <FormGroup controlId="mobile">
                  <Control model=".mobile" type="tel" placeholder="Mobile" component={FormControl}/>

                  <Errors
                    show={{ touched: true, focus: false }}
                    className="errors"
                    model="deep.staff_member"
                    messages={{
                      communication: 'You must enter at least one communication preference.'
                    }}/>

                  <Errors
                    show={{ touched: true, focus: false }}
                    className="errors"
                    model=".mobile"/>
                </FormGroup>
              </Col>
              <Col lg={4} className="permissions-matrix">
                <Row>
                  <Col lg={8} className="permission-label">
                    <h5>Permissions</h5>
                  </Col>
                  <Col lg={4} className="permission-label">
                    <Col lg={6} xs={4}>
                      <h5 className="mobilbuttons">Yes</h5>
                    </Col>
                    <Col lg={6} xs={4}>
                      <h5 className="mobilbuttons">No</h5>
                    </Col>
                  </Col>
                </Row>
                {
                  this.state.selectedOutlet && staff_member_relationships.permissions &&

                  staff_member_relationships.permissions
                    .filter(permission => staff_member_relationships.pay_for_performance === 'N' || permission.name !== 'Manage staff rewards')
                      .map(item => {
                    if (item.ordering && this.state.selectedOutlet.ordering ||
                      item.reward && this.state.selectedOutlet.reward ||
                      !item.ordering && !item.reward) {
                      return (
                        <Row key={item.id}>
                          <Col lg={8}>
                            <div>{item.name}</div>
                          </Col>
                          <Col lg={4}>
                            <Col lg={6} xs={12}>
                              <Control.radio style={{display: 'inline'}} model={`.permission_ids[${item.id}].checked`}
                                             value="true"
                                             validators={{
                                               required: validators.required(undefined, undefined)
                                             }}
                                             component={Radio}/>
                              <h5 className="buttons">Yes</h5>
                            </Col>
                            <Col lg={6} xs={12}>
                              <Control.radio style={{display: 'inline'}} model={`.permission_ids[${item.id}].checked`}
                                             value="false"
                                             validators={{
                                               required: validators.required(undefined, undefined)
                                             }}
                                             component={Radio}/>
                              <h5 className="buttons">No</h5>
                            </Col>
                          </Col>
                        </Row>
                      )
                    }
                  })
                }
              </Col>
            </Row>
            <Row>
              <Col lg={8} className="job-title">
                <UserJobTitleSelector label={false} />
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                {staff_member_id === -1 &&  <Control.checkbox className="float-right" model=".agreed" component={Checkbox}>
                  <span className="confirm">I confirm this staff member is eligible to be a member of <strong>ignite</strong></span>
                </Control.checkbox>}
              </Col>
              <Col lg={12}>
                {staff_member_id === -1 && <ArrowButton color="white"
                                                        className="pull-right"
                                                        arrow={false}
                                                        disabled={!staff_member.agreed || !formValid}>Add staff member</ArrowButton>}
                {staff_member_id !== -1 && <ArrowButton color="white"
                                                        className="pull-right"
                                                        arrow={false}
                                                        disabled={!formValid}>Save</ArrowButton>}
                {staff_member_id !== -1 && <ArrowButton color="white"
                                                        className="pull-right"
                                                        arrow={false}
                                                        submit={false}
                                                        onClick={this.onRemoveFromStore}>Remove from store</ArrowButton>}
              </Col>
            </Row>
          </Form>
        </Panel>
      </Col>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    staff_member: state.deep.staff_member,
    staff_member_id: state.staff.staff_member_id,
    staff_member_status: state.staff.staff_member_status,
    staff_member_relationships: state.staff.staff_member_relationships,
    saveLink: state.staff.saveLink,
    removeLink: state.staff.removeLink,
    formValid: state.deep.forms.staff_member.$form.valid,
  };
};

export default connect(mapStateToProps)(EditStaff);



// WEBPACK FOOTER //
// ./src/components/my-staff/edit-staff.jsx